import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { UserDetailActions } from "./model";

export const UserDetailController = () => {
  const dispatch = useDispatch();

  const {
    value: { data },
  } = useSelector((rootState) => rootState.userDetail.userDetail);

  useEffect(() => {
      dispatch(UserDetailActions.getUserDetail());
  }, [dispatch]);

  const currentUser = data;
  return { currentUser };
};
